import { isTypeLandingPageHeader } from '@platform/contentful';
import { Entry } from 'contentful';
import Divider from './util/Divider';
import ContentfulLargeCta from './ContentfulLargeCta';

const ContentfulLandingPageHeader = ({
  entry,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry: Entry<any, 'WITHOUT_UNRESOLVABLE_LINKS', 'en-US'> | undefined;
}) => {
  if (!entry || !isTypeLandingPageHeader(entry)) {
    return null;
  }

  return (
    <>
      <div className='-mx-2 sm:-mx-4 px-2 py-6 flex flex-col sm:flex-row bg-gray-50 items-center'>
        <div className='flex flex-col sm:px-12 sm:py-10 sm:max-w-[40%]'>
          <h1 className='mt-3 font-header text-4xl sm:text-5xl leading-11 sm:leading-14 font-bold text-gray-500'>
            {entry.fields.header}
          </h1>
          <Divider className='!w-34' />
          <h2 className='font-header text-base sm:text-xl leading-5 sm:leading-7 font-medium text-gray-400'>
            {entry.fields.headerDescription}
          </h2>
          <div className='mt-6'>
            <ContentfulLargeCta entry={entry.fields.cta} />
          </div>
        </div>
        <div
          className='-mx-2 mt-8 -mb-6 sm:-my-6 w-screen h-[30vh] min-h-[300px] max-h-[600px] sm:h-full sm:min-h-[60vh] sm:max-h-[600px] bg-cover sm:bg-center'
          style={{
            // TODO: Technically we use optimole here, though it's unclear when and why we use Optimole in some contexts and not others
            backgroundImage: `url('https://optimole.movingworlds.org/h:960/w:1920/rt:fill/q:85/${entry.fields.headerImage?.fields.file?.url}?fit=fill&w=1920&h=960')`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'cover',
            backgroundSize: 'cover',
          }}
        />
      </div>
    </>
  );
};

export default ContentfulLandingPageHeader;
